import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Lock } from 'lucide-react';
export function FinalOfferSection() {
  const SECTION_ID = 'compra-final';
  return <section id="compra-final" className="py-24 bg-forest text-white relative overflow-hidden" data-id="element-91">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-92"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-93">
        <FadeIn data-id="element-94">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-cream" data-id="element-95">
            Recupera el control de tu cuerpo hoy.
          </h2>
          <p className="text-xl text-emerald-light mb-12 max-w-2xl mx-auto" data-id="element-96">
            No permitas que la inflamación se convierta en una enfermedad
            crónica por falta de información correcta.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-97">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 md:p-12 rounded-3xl max-w-2xl mx-auto" data-id="element-98">
            <div className="mb-8" data-id="element-99">
              <span className="text-gray-300 line-through text-xl mr-3" data-id="element-100">
                Valor: $49.99
              </span>
              <span className="text-5xl font-bold text-emerald-light" data-id="element-101">
                $9.99
              </span>
            </div>

            <CTAButton className="w-full md:w-auto mb-6" onClick={() => window.open('https://vitalizateahora.com/cart/51947323818215:1', '_blank')} data-id="element-102" />

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mt-6" data-id="element-103">
              <div className="flex items-center gap-2" data-id="element-104">
                <Lock className="w-4 h-4 text-emerald-light" data-id="element-105" />
                <span data-id="element-106">Compra 100% segura y privada</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-gray-500 rounded-full" data-id="element-107"></div>
              <div className="flex items-center gap-2" data-id="element-108">
                <ShieldCheck className="w-4 h-4 text-emerald-light" data-id="element-109" />
                <span data-id="element-110">Acceso instantáneo después del pago</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}